module.exports = "<svg id=39feebe1-14d2-4e34-abe4-11dcf9081a65 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>OK</title><path d=M12,21a9,9,0,1,0-9-9A9,9,0,0,0,12,21ZM12,4a8,8,0,1,1-8,8A8,8,0,0,1,12,4Z /><path d=M10.08,15.4a.52.52,0,0,0,.36.14.5.5,0,0,0,.35-.14l6.09-6.09a.5.5,0,0,0-.71-.71l-5.73,5.74L7.83,11.73a.5.5,0,0,0-.71,0,.5.5,0,0,0,0,.7Z /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/ok.svg
// module id = 164
// module chunks = 0